<template>
  <section
    class="md:grid md:grid-cols-12 mt-30 md:mt-60 lg:mt-100 container gap-30"
  >
    <div class="md:col-span-8">
      <h2 class="is-2 leading-none">
        {{ $texts('product.descriptionTitle') }}
      </h2>
      <div
        v-if="body"
        class="content mt-20 lg:mt-40 space-y-20 md:space-y-30"
        v-html="body"
      />
    </div>

    <div
      class="mt-60 md:mt-40 lg:mt-0 md:col-span-4 lg:col-span-3 lg:col-start-10 space-y-60"
    >
      <ProductLabels :terms="sustainability" />
      <ProductLabels
        :title="$texts('product.awardedTitle')"
        :terms="awards"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import type {
  TaxonomyTermAwardLabelsFragment,
  TaxonomyTermSustainabilityLabelsFragment,
} from '#build/graphql-operations'

defineProps<{
  body?: string
  sustainability?: TaxonomyTermSustainabilityLabelsFragment[]
  awards?: TaxonomyTermAwardLabelsFragment[]
}>()
</script>
